import * as types from '../mutation-types';
import auth from '../../api/auth';

const initialState = {
  authToken: localStorage.getItem('token'),
  loggingIn: false,
  notifications: [],
};

const actions = {
  login({ commit, state }, { username, password }) {
    commit(types.LOGIN);
    auth.login({ username, password }).then((response) => {
      if (response.data.token) {
        const token = response.data.token;
        commit(types.LOGIN_SUCCESS, { token });
      } else {
        commit(types.LOGIN_FAILURE, { error: 'Unrecognized api error. Please try again later or notify the webmaster.' });
      }
    }, (error) => {
      if (error.response.status === 401) {
        commit(types.LOGIN_FAILURE, { error: 'Invalid username or password.' });
      } else {
        commit(types.LOGIN_FAILURE, { error: 'There was an error contacting the server. Please try again later.' });
      }
    });
  },
  logout({ commit }) {
    commit(types.LOGOUT);
  },
  clearNotifications({ commit }) {
    commit(types.CLEAR_AUTH_NOTIFICATIONS);
  },
};

const mutations = {
  [types.LOGIN](state) {
    state.loggingIn = true;
    state.loginError = null;
    state.notifications = [];
  },
  [types.LOGIN_SUCCESS](state, { token }) {
    localStorage.setItem('token', token);
    state.loggingIn = false;
    state.authToken = token;
    state.loginError = null;
    state.notifications = [{
      message: 'Logged in.', type: 'success',
    }];
  },
  [types.LOGIN_FAILURE](state, { error }) {
    state.loggingIn = false;
    state.authToken = null;
    state.notifications = [{
      message: error, type: 'error',
    }];
  },
  [types.LOGOUT](state) {
    localStorage.removeItem('token');
    state.authToken = null;
    state.loggingIn = false;
    state.notifications = [{
      message: 'Logged out.', type: 'success',
    }];
  },
  [types.CLEAR_AUTH_NOTIFICATIONS](state) {
    state.notifications = [];
  },
};

export default {
  state: initialState,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js